import React, { useEffect, useState, useRef } from 'react';
import { postUserLog } from './api/index';

const ActivityTracker = () => {
  const [isMoving, setIsMoving] = useState(false);  // Tracks if user is moving
  const [isOnline, setIsOnline] = useState(navigator.onLine);  // Tracks if user is online
  const activityRef = useRef(false);  // Tracks movement over 10 minutes
  const lastOnlinePeriod = useRef(null);  // Stores the last 10-minute online tracking period

  // Function to handle mouse and keyboard events
  const handleUserActivity = () => {
    setIsMoving(true);  // Immediate feedback for activity in the UI (if needed)
    activityRef.current = true;  // Marks activity in the 10-minute window
  };

  // Function to send data to the server after the 10-minute period
  const sendActivityData = () => {
    const lastPeriod = lastOnlinePeriod.current;
    const timePeriod = `${lastPeriod.start.toLocaleTimeString()} - ${lastPeriod.end.toLocaleTimeString()}`;

    const data = {
      status: isOnline ? (activityRef.current ? 'online' : 'offline') : 'offline',
      movement: activityRef.current,  // true if there was activity in the last 10 minutes
      timePeriod: timePeriod,
    };

    console.log('Sending activity data:', data);

    // Call the postUserLog function instead of fetch
    postUserLog(data)
      .then(response => {
        console.log('Successfully sent activity:', response.data);
      })
      .catch(error => {
        console.error('Error sending activity:', error);
      });
  };

  // Set up activity listeners and the 10-minute interval for sending data
  useEffect(() => {
    // Attach event listeners for mouse and keyboard activity
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);

    // Start the first 10-minute tracking period
    lastOnlinePeriod.current = { start: new Date(), end: new Date(new Date().getTime() + 20 * 60 * 1000) };

    const sendDataInterval = setInterval(() => {
      // Update the end time of the 10-minute period
      lastOnlinePeriod.current.end = new Date();

      // Send data if the user was online for the last 10 minutes
      sendActivityData();

      // Reset activity tracking for the next 10-minute period
      activityRef.current = false;  // Reset movement status for the next window

      // Update the start time of the new 10-minute period
      lastOnlinePeriod.current.start = new Date();
    }, 1200000);  // 20 minutes in milliseconds

    // Listen for changes in online/offline status
    window.addEventListener('online', () => setIsOnline(true));
    window.addEventListener('offline', () => setIsOnline(false));

    console.log('Activity Tracker is running...');

    // Clean up event listeners and intervals on component unmount
    return () => {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('online', () => setIsOnline(true));
      window.removeEventListener('offline', () => setIsOnline(false));
      clearInterval(sendDataInterval);
    };
  }, [isOnline]);  // Dependencies to re-run when online status changes

  return null;  // This component doesn't render anything
};

export default ActivityTracker;
